import { checkAndRefreshToken } from '@shared/api/helpers/sendRequest';
// eslint-disable-next-line
import { sendProjectRequest } from './sendProjectRequest';

function createSendRequest(cstm, withToken) {
  return async function request(route, method = 'get', body, config = {}) {
    let tokenOK = false;
    if (withToken) {
      tokenOK = await checkAndRefreshToken();
    }
    let responseData = null;
    if (!withToken || tokenOK) {
      responseData = await sendProjectRequest(
        route,
        method,
        body,
        config,
        cstm
      );
    }
    return responseData;
  };
}

export const request = {
  send() {
    throw new Error('SendRequest() not initialized.');
  },
  sendWithoutToken() {
    throw new Error('sendWithoutToken() not initialized.');
  },
};

export function initAPI(cstm) {
  request.send = createSendRequest(cstm, true);
  request.sendWithoutToken = createSendRequest(cstm, false);
}
